class VideoBlock {
  static isApiScriptLoaded = false

  static loadApi = () => {
    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'

    const firstScriptTag = document.querySelector('script')
    firstScriptTag.after(tag, firstScriptTag)
  }

  constructor(wrap) {
    this.elements = {
      wrap
    }

    this.statuses = {
      active: false
    }

    this.attributes = {
      video: wrap.dataset.src,
      type: wrap.dataset.type
    }

    this.init()
  }

  defineElements() {
    this.elements.player = document.createElement('div')
    this.elements.wrap.querySelector('.video-block__player').append(this.elements.player)
    this.elements.btn = this.elements.wrap.querySelector('.video-block__thumb')
  }

  youtubeInit() {
    const definePlayer = () => {
      this.onChangeYT = () => {
        const state = this.player.getPlayerState()
        if (state === 1) {
          this.statusToPlay()
        } else if (state === 2) {
          this.statusToStop()
        }
      }

      this.player = new YT.Player(this.elements.player, {
        videoId: this.attributes.video,
        playerVars: {
          'playsinline': 1,
          'controls': 0,
          'showinfo': 0,
          'frameborder': 0
        },
        events: {
          'onReady': this.play.bind(this),
        }
      })
    }

    this.elements.btn.removeEventListener('click', this.youtubeInitBind)

    if (!VideoBlock.isApiScriptLoaded) {
      const load = () => {
        return new Promise((resolve, reject) => {
          VideoBlock.loadApi()
          VideoBlock.isApiScriptLoaded = true

          resolve()
        })
      }

      load().then(() => {
        const startLoop = () => {
          setTimeout(() => {
            if (window.YT) {
              window.YT.ready(() => {
                this.play = () => {
                  this.player.playVideo()
                }

                definePlayer()
              })
            } else {
              startLoop()
            }
          }, 50)
        }
        startLoop()
      })
    } else {
      this.play = () => {
        this.player.playVideo()
      }

      definePlayer()
    }

    this.statuses.active = true
    this.elements.wrap.classList.add('loaded')
  }

  isUrlSrc() {
    return this.attributes.video.includes('http') || this.attributes.video.includes('youtube') || this.attributes.video.includes('watch?v=') || this.attributes.video.includes('youtu.be')
  }

  getIdFromUrl() {
    let result

    if (this.attributes.video.includes('youtube.com')) {
      const index = this.attributes.video.indexOf('watch?v=')
      result = this.attributes.video.substring(index + 8)
      
      if (result.indexOf('&') > 0) {
        result = result.substring(0, result.indexOf('&'))
      }
    } else if (this.attributes.video.includes('youtu.be')) {
      const index = this.attributes.video.indexOf('youtu.be/')
      result = this.attributes.video.substring(index + 9)

      if (result.indexOf('?t=') > 0) {
        result = result.substring(0, result.indexOf('?t='))
      }
    }

    return result
  }

  vimeoInit() {
    this.elements.wrap.classList.add('loaded')
  }

  defineEvents() {
    if (this.attributes.type === 'youtube') {
      this.youtubeInitBind = this.youtubeInit.bind(this)
      this.elements.btn.addEventListener('click', this.youtubeInitBind)

      if (this.isUrlSrc()) {
        this.attributes.video = this.getIdFromUrl()
      }
    } else if (this.attributes.type === 'vimeo') {
      this.vimeoInitBind = this.vimeoInit.bind(this)
      this.elements.btn.addEventListener('click', this.youtubeInitBind)
    }
  }

  init() {
    this.defineElements()
    this.defineEvents()
  }
}

const videoBlocks = document.querySelectorAll('.video-block')
videoBlocks.forEach(videoEl => {
  new VideoBlock(videoEl)
})